/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespAppliedFilters_searchBrowse$ref = any;
type SbSharedRefineMenuDisplayPrefsSelect_searchBrowse$ref = any;
type SbSharedRefineMenuFilters_searchBrowse$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenu_searchBrowse$ref: FragmentReference;
export type SbRespRefineMenu_searchBrowse = {|
  +topCategoryL1: ?VerticalType,
  +$fragmentRefs: SbRespAppliedFilters_searchBrowse$ref & SbSharedRefineMenuFilters_searchBrowse$ref & SbSharedRefineMenuDisplayPrefsSelect_searchBrowse$ref,
  +$refType: SbRespRefineMenu_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '20c53b583ece3534fca4f24dfe4f17c7';
module.exports = node;
